import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";

import courseServices from "../../../services/courseServices";
import lessonServices from "../../../services/lessonServices";
import TeacherPythonIDEWrapper from "../../IDEs/wrappers/teacher/TeacherPythonIDEWrapper";
import TeacherSmoothyIDEWrapper from "../../IDEs/wrappers/teacher/TeacherSmoothyIDEWrapper";
import TeacherWebIDEWrapper from "../../IDEs/wrappers/teacher/TeacherWebIDEWrapper";
import Modal from "../../Modal";

const CodeSolutionsModal = forwardRef((_, ref) => {
  const [IDEType, setIDEType] = useState("");
  const [selectedLessonID, setSelectedLessonID] = useState("");
  const [lessonName, setLessonName] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [codeData, setCodeData] = useState(null);
  const [isGraduationProject, setIsGraduationProject] = useState("");

  useImperativeHandle(ref, () => ({
    openModal(lessonID, IDEType, lessonName, isGraduationProject) {
      setSelectedLessonID(lessonID);
      setIDEType(IDEType);
      setLessonName(lessonName);
      setIsGraduationProject(isGraduationProject);
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const getCodeSolution = async () => {
    try {
      const options = isGraduationProject ? { type: "graduation" } : {};
      let response;

      if (isGraduationProject) {
        response = await lessonServices.getLessonProject(selectedLessonID, options);
      } else {
        const res = await courseServices.getCodeSolution(selectedLessonID);
        response = {
          code: {
            smoothy: res.code,
          },
        };
      }

      setCodeData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      getCodeSolution();
    }

    return () => {
      setCodeData(null);
    };
  }, [isOpen]);

  return (
    <Modal isFullScreen isOpen={isOpen} onClose={handleCloseModal}>
      {codeData && IDEType === "smoothy" && (
        <TeacherSmoothyIDEWrapper
          type="solutions"
          lessonID={selectedLessonID}
          codeData={codeData}
          lessonName={lessonName}
          projectGoal={{
            projectGoal: codeData?.challenge_statement,
            name: codeData?.name,
            image: codeData?.image,
          }}
        />
      )}

      {codeData && IDEType === "web" && (
        <TeacherWebIDEWrapper
          type="solutions"
          codeData={codeData}
          lessonName={lessonName}
          projectGoal={{
            projectGoal: codeData?.challenge_statement,
            name: codeData?.name,
            image: codeData?.image,
          }}
        />
      )}

      {codeData && IDEType === "python" && (
        <TeacherPythonIDEWrapper
          type="solutions"
          codeData={codeData}
          lessonName={lessonName}
          projectGoal={{
            projectGoal: codeData?.challenge_statement,
            name: codeData?.name,
            image: codeData?.image,
          }}
        />
      )}
    </Modal>
  );
});

export default CodeSolutionsModal;
